export const GuideController = {
    brand(): void {},
    style(): void {},
    components(): void {},
    sections(): void {},
};
